import TileLayer from "ol/layer/Tile";
import {OSM} from "ol/source";
import {getLayerAttributes, getLayerNamePrefix} from "@/helpers/ol/ol-layer-helper";

/**
 * Add Open Street Map
 * @param map
 * @param service
 */
export function addServiceOsm(map, service) {
    map.addLayer(
        new TileLayer({
            name: getLayerNamePrefix() + service.id,
            zIndex: service.service.zIndex,
            source: new OSM(),
            attributions: getLayerAttributes(service)
        })
    )
}
